import { Text, colors } from '@newfront-insurance/core-ui';
import type { JSX } from 'react';

import type { Address } from '../../types';

interface Props {
  address?: Address;
  width?: number | string;
  color?: string;
}
export function AddressDisplayField({ address, width = 400, color = 'primary' }: Props): JSX.Element {
  return (
    <div className={`relative w-[${width}]`}>
      <div className="border-steel-200 text-steel-500 block h-[40px] w-full appearance-none rounded-xs border border-solid bg-white py-2 pr-[28px] pl-2 text-base leading-[21px]">
        <Text color={address?.formattedAddress ? color : colors.steel[300]}>
          {address?.formattedAddress || 'No address'}
        </Text>
      </div>
    </div>
  );
}
